import * as RequestConfig from '../constant/RequestConfig';
import ConstantConfig from '../constant/Constant';

const Config = {
    ...RequestConfig,
    ...ConstantConfig.dataUrl
};

const context = require.context('./', false, /\.js$/);
const mocks = context.keys()
    .filter(path => path !== './index.js')
    .reduce((mocks, path) => {
        const name = path.replace(/^\.\/|.js$/g, '');
        if (Config[name]) {
            mocks[Config[name].url] = context(path).default;
        }
        return mocks;
    }, {});

export default {...mocks};